import Hero from "./Hero";
import CardLayout from "./CardLayout";
import Browserframe from "./BrowserFrame";
import useSlideAnimation from "../Hooks/useSlideAnimation";
import React from 'react';

const projects1 = [
  {
    name: "XINU OS: Operating System",
    type: "Adding Features to XINU through C and Assembly",
    github: "https://github.com/ncsu-csc-501/project1-pvinoda/tree/main",
    live: "https://github.com/ncsu-csc-501/project1-pvinoda/tree/main",
    comp: (
      <img src="/os.jpeg" className="h-[22rem] mt-[-5rem] w-[23rem] rounded-3xl" alt="xinu-os" />
    ),
  },
  {
    name: "SEEDGuard.ai ",
    type: "Python Library for Automated Software Engineering (Generative AI)",
    github: "https://github.com/SEEDGuard",
    live: "https://seedguard.ai/index.html",
    comp: (
      <Browserframe
        comp={
          <img src="/airbnb.png" className="max-h-[32rem]" alt="airbnb-clone" />
        }
      />
    ),
  },
];

const projects2 = [
  {
    name: "FungAI: A Deep Learning Application for Image Segmentation",
    type: "High Performance Research Web Application",
    github: "https://github.com/pvinoda/fungai-segmentation-hpc",
    live: "https://fungai.cals.ncsu.edu/",
    comp: (
      <Browserframe
        comp={
          <img src="/planetzy.png" className="max-h-[20rem]" alt="planetzy" />
        }
      />
    ),
  },
  {
    name: "Fault Tolerant Cloud Database",
    type: "Distributed Systems",
    github: "https://github.com/pvinoda/fault-tolerant-cloud-db",
    live: "https://github.com/pvinoda/fault-tolerant-cloud-db",
    comp: (
      <Browserframe
        comp={
          <img src="/database.png" className="max-h-[20rem]" alt="planetzy" />
        }
      />
    ),
  },
];

const workProjects = [
  {
    name: "HPE Infosight",
    type: "Advanced Infrastructure for Enterpise AI",
    github: "",
    live: "https://www.hpe.com/us/en/software/infosight.html",
    comp: (
      <img
        src="/hyperswitch.png"
        className="max-h-[28rem] rounded-xl"
        alt="hyperswitch"
      />
    ),
  },
  {
    name: "Lexis Practical Guidance",
    type: "Dashboard for Legal Analytics",
    github: "",
    live: "https://www.lexisnexis.com/en-us/products/lexis-plus/practical-guidance.page",
    comp: (
      <Browserframe
        comp={
          <img
            src="/juspay_dashboard.png"
            className="max-h-[32rem]"
            alt="juspay-dashboard"
          />
        }
      />
    ),
  },
];

export default function Home() {
  let projectAni = useSlideAnimation(0.4, "big");

  return (
    <div className="flex flex-col gap-2 justify-center items-center">
      <Hero
        hero={["Hi. I'm Prabhanjan.", "A Software Developer."]}
        description={
          "Passionate Software Developer with experience in large-scale distributed systems, full-stack web development, data engineering and AI-driven software, currently pursuing a Master's in Computer Science at NC State University."
        }
      />
      <div className="mt-20 mb-16" style={projectAni}>
        <CardLayout
          left={40}
          right={60}
          cardColor={["#d891f2", "#F8F4E1"]}
          contents={projects1}
        />
        <CardLayout
          left={60}
          right={40}
          cardColor={["#bddff9", "#F6DCAC"]}
          contents={projects2}
        />
      </div>
      <Hero
        hero={["Work"]}
        hideStar={true}
        description={
          "Glimpse into the array of projects and products I have been actively contributing during my tenure with past and current companies."
        }
      />
      <div className="my-20" style={projectAni}>
        <CardLayout
          left={40}
          right={60}
          cardColor={["#bddff9", "#e2c8b2"]}
          contents={workProjects}
        />
      </div>
    </div>
  );
}
